export default __webpack_public_path__ + "static/media/dragon.ad73bf96.svg";